export { default } from "./TextInputControl";
